<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
    
                <div class="row" id="dta_ref">
                    <div class="col-12 m-record">
                        <div class="row nav-top auto">
                            <div class="col-2 xtl"><span class="nav-back wt" onclick="window.location.href='#/promotion'"></span></div>
                            <div class="col-8 tfw-5 tf-18">Agency Privilege</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row mr-0 mt-4 mb-4 bdr-6">
                            <div class="col-12 pa-0 tf-16 pt-2 pb-3">3 level invitess, each user will generate
                                commission</div>
                            <div class="col-12 pt-2 mxui wt"><img src="../assets/includes/images/3levelinv.jpg" style="width: 100%;">
                                <div class="class pt-2 pb-2 mcpl" onclick="window.location.href='#/IncomeDetails'">My order commission: <span
                                        class="tfs-org tfw-6" id="myodcom">0</span><span class="pl-2"><img class="pb-1"
                                            src="../assets/includes/icons/circleRightIcon.png" height="24"></span></div>
                            </div>
                            <div class="col-12 mt-2 xtc">
                                <div class="pa-10 mb-2 tf-16 tfs-w wdmax">Refer To Get</div>
                            </div>
                            <div class="col-12 pa-0 tf-16 pt-2 pb-3">Reward 450 for each registered user</div>
                            <div class="col-12 mxui wt"><img src="../assets/includes/images/refer_system.jpg" style="width: 100%;">
                                <div class="class tf-16 pt-2 pb-2 mcpl" onclick="window.location.href='#/IncomeDetails'">My invitation revenue: <span
                                        class="tfs-org tfw-6" id="myrevn">0</span><span class="pl-2"><img class="pb-1"
                                            src="../assets/includes/icons/circleRightIcon.png" height="24"></span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>